import {userGuard} from "../middleware/guards";
import Me from "~/components/pages/user/Me";
import Confirm from "~/components/pages/user/Confirm";

export default [
    {
        path: '/me',
        name: 'Me',
        component: Me,
        beforeEnter: userGuard
    },

    {
        path: '/confirm',
        name: 'Confirm',
        component: Confirm,
        beforeEnter: userGuard
    },
]


